import {
    CreateFutureOrderAPIResponseType,
    FXOrderFormRequiredType,
    FXOrderFormType,
    FXOrderTransactionAcknowledgementType, FXOrderTransactionAcknowledgementTypeForFuture,
    FXType
} from "../../../../../types/fx.type";
import {
    DEFAULT_FX_ORDER_CURRENCY_AMOUNT_DECIMAL_POINT,
    FX_ORDER_CONFIRM_STATUS_CODE, FX_ORDER_TRANSACTION_ACKNOWLEDGEMENT_STATUS_CODE,
    FX_ORDER_TRANSACTION_ACKNOWLEDGEMENT_STATUS_TYPE
} from "../../../../../constants/fx.constant";
import {getIntlObject} from "../../../../../utils/intl";
import moment from "moment/moment";
import {formatNumber} from "../../../../../utils/common.utils";
import {getConversionFee} from "../../../order";
import {renderRate} from "../../../../../components/order/CalculationCard";
import {store} from "../../../../../store/store";
import {getDpUqBySymbol} from "../../../../../components/fx/service/getDpUqBySymbol";
import formatFXRawList from "../formatFXRawList";
import { formatDateWithFixedTime as futureOrderFailedFixedTime } from "../formatS2UMOFailOrder/formatMarketS2UOrder";
import getRateByDealt from "../../../getRateByDealt";

// function formatDateString(input: string): string {
//     // Extracting year, month, day, etc. from the string
//     const year = parseInt(input.substring(0, 4), 10);
//     const month = parseInt(input.substring(4, 6), 10) - 1; // Month is 0-indexed in JavaScript
//     const day = parseInt(input.substring(6, 8), 10);
//     const hour = parseInt(input.substring(8, 10), 10);
//     const minute = parseInt(input.substring(10, 12), 10);
//     const second = parseInt(input.substring(12, 14), 10);
//
//     // Create a new date object
//     const date = new Date(year, month, day, hour, minute, second);
//
//     // Format the date
//     const options: Intl.DateTimeFormatOptions = {
//         year: 'numeric', month: 'long', day: 'numeric',
//         hour: '2-digit', minute: '2-digit', hour12: true
//     };
//     return date.toLocaleDateString('en-US', options);
// }

function formatDateString(input: string): string {
    // Extracting year, month, day, etc. from the string
    const year = parseInt(input.substring(0, 4), 10);
    const month = parseInt(input.substring(4, 6), 10) - 1; // Month is 0-indexed in JavaScript
    const day = parseInt(input.substring(6, 8), 10);
    const hour = parseInt(input.substring(8, 10), 10);
    const minute = parseInt(input.substring(10, 12), 10);
    const second = parseInt(input.substring(12, 14), 10);

    // Create a new date object
    const date = new Date(year, month, day, hour, minute, second);

    // Extract date components
    const yyyy = date.getFullYear().toString();
    const MM = (date.getMonth() + 1).toString().padStart(2, '0'); // Month is 0-indexed
    const dd = date.getDate().toString().padStart(2, '0');
    const HH = date.getHours().toString().padStart(2, '0');
    const mm = date.getMinutes().toString().padStart(2, '0');
    const ss = date.getSeconds().toString().padStart(2, '0');

    // Format the date
    return `${yyyy}-${MM}-${dd} ${HH}:${mm}:${ss}`;
}


// function formatDateWithFixedTime(dateString: string): string {
//     const date = new Date(dateString);
//     const formattedDate = date.toLocaleDateString("en-GB", {
//         day: '2-digit',
//         month: 'long',
//         year: 'numeric'
//     });
//
//     return formattedDate + "\n11:59:59 PM";
// }

export function formatDateWithFixedTime(dateString: string, show24hrFormat: boolean): any {
    const date = new Date(dateString);

    // Extract date components
    const yyyy = date.getFullYear().toString();
    const MM = (date.getMonth() + 1).toString().padStart(2, '0'); // Month is 0-indexed
    const dd = date.getDate().toString().padStart(2, '0');
    const HH = date.getHours().toString().padStart(2, '0');
    const mm = date.getMinutes().toString().padStart(2, '0');
    const ss = date.getSeconds().toString().padStart(2, '0');
    const MMMM = new Intl.DateTimeFormat('en', { month: 'long' }).format(date);

    // Format the date
    if (show24hrFormat) {
        return `${yyyy}-${MM}-${dd} ${23}:${59}:${59}`;
    } else {
        return `${dd} ${MMMM} ${yyyy}, ${11}:${59}:${59}PM`;
    }
}


function formatDecimal(inputNumber: string | number, numberOfDecimals: number): string {
    var number = typeof inputNumber === 'string' ? parseFloat(inputNumber) : inputNumber;
    if (isNaN(number)) {
        return 'Invalid number';
    }
    if(number>0 && number % 1 !== 0){
		if(number.toString().split(".")[1].length > numberOfDecimals){
			number = Number.parseFloat(number+"1")
		}
	}
    return number.toFixed(numberOfDecimals);
}

export const formatCreateFutureOrder = (
    response: CreateFutureOrderAPIResponseType,
    fxOrderForm: FXOrderFormType
): FXOrderTransactionAcknowledgementTypeForFuture | FXOrderTransactionAcknowledgementType => {
    const intl = getIntlObject();
    const calculateExecutionRateFromTargetRate = (targetRate: string | number, limitMarkup: number):number => {
        const isBuy = fxOrderForm.target.currency === fxOrderForm.fx!.currencies[0]
        const dp = getDpUqBySymbol(fxOrderForm.fx?.symbol!).dp
        const impactToRate = limitMarkup * (10**(-dp))
        if(isBuy){
            return Number(targetRate) - impactToRate
        }else{
            return Number(targetRate) + impactToRate
        }
    }
    if (response.responseCode === FX_ORDER_CONFIRM_STATUS_CODE.SUCCESS) {
        // Success case
        const fx: FXType = {
            //@ts-ignore
            ...formatFXRawList([response.data.symbol])[0],
            //@ts-ignore
            bid: isNaN(parseFloat(response.data.limit))
                ? null
                //@ts-ignore
                : parseFloat(response.data.limit),
            //@ts-ignore
            ask: isNaN(parseFloat(response.data.limit))
                ? null
                //@ts-ignore
                : parseFloat(response.data.limit),

        };

        let contraCurrency: string = "-";
         //@ts-ignore
        if (fx.currencies[0] === response.data.dealtCurr) {
            contraCurrency = fx.currencies[1] === "" ? "-" : fx.currencies[1];
            //@ts-ignore
        } else if (fx.currencies[1] === response.data.dealtCurr) {
            contraCurrency = fx.currencies[0] === "" ? "-" : fx.currencies[0];
        }

    let msg= {
            transactionStatus: FX_ORDER_TRANSACTION_ACKNOWLEDGEMENT_STATUS_TYPE.SUCCESS,
            statusDescription: intl.formatMessage({
                id: "app.page.futureReceipt.statusDescription.success.text",
            }),
            statusCode: FX_ORDER_TRANSACTION_ACKNOWLEDGEMENT_STATUS_CODE.SUCCESS,
            orderId: response.data.orderId,
            transactionDate: moment
                    .utc(response.data.inputDate, "YYYYMMDDHHmmss")
                    .local()
                    .format("YYYY-MM-DD HH:mm:ss"),
            fromAccount: fxOrderForm.bankAccount.source!.id,
            fromAccountName: fxOrderForm.bankAccount.source!.label,
            toAccount: fxOrderForm.bankAccount.target!.id,
            toAccountName: fxOrderForm.bankAccount.target!.label,
            convertedFrom:
            //@ts-ignore
                response.data.amount?(fxOrderForm.source.currency === response.data.dealtCurr
                    //@ts-ignore
                    ? `${response.data.dealtCurr} ${formatNumber(
                        //@ts-ignore
                        response.data.amount,
                        DEFAULT_FX_ORDER_CURRENCY_AMOUNT_DECIMAL_POINT
                    )}`
                    : `${contraCurrency} ${formatNumber(
                        // @ts-ignore 
                        response.data.contraAmount,
                        DEFAULT_FX_ORDER_CURRENCY_AMOUNT_DECIMAL_POINT
                    )}`):`${fxOrderForm.source.currency} ${formatDecimal(fxOrderForm.source.amount.value, DEFAULT_FX_ORDER_CURRENCY_AMOUNT_DECIMAL_POINT)}`,
            amountReceived:
            //@ts-ignore
                response.data.amount?fxOrderForm.target.currency === response.data.dealtCurr
                    //@ts-ignore
                    ? `${response.data.dealtCurr} ${formatNumber(
                        //@ts-ignore
                        response.data.amount,
                        DEFAULT_FX_ORDER_CURRENCY_AMOUNT_DECIMAL_POINT
                    )}`
                    : `${contraCurrency} ${formatNumber(
                        // @ts-ignore
                        response.data.contraAmount,
                        DEFAULT_FX_ORDER_CURRENCY_AMOUNT_DECIMAL_POINT
                    )}`:`${fxOrderForm.target.currency} ${formatDecimal(fxOrderForm.target.amount.value, fxOrderForm.fx?.decimalPoint as number)}`,
            targetRate: renderRate(fxOrderForm.fx!.currencies[0], fxOrderForm.fx!.currencies[1], fxOrderForm.futureTargetRate!,getDpUqBySymbol(fxOrderForm.fx?.symbol!).dp, getDpUqBySymbol(fxOrderForm.fx?.symbol!).uq),
            executionRate: renderRate(fxOrderForm.fx!.currencies[0], fxOrderForm.fx!.currencies[1], calculateExecutionRateFromTargetRate(fxOrderForm.futureTargetRate!, response.data.limitMarkup),getDpUqBySymbol(fxOrderForm.fx?.symbol!).dp, getDpUqBySymbol(fxOrderForm.fx?.symbol!).uq),
            transactionType: intl.formatMessage({
                id: "app.page.transactionReceipt.transactionType.future.text",
            }),
            conversionFee: `${fxOrderForm.fee.currency} ${formatNumber(
                getConversionFee(),
                DEFAULT_FX_ORDER_CURRENCY_AMOUNT_DECIMAL_POINT
            )}`,
            receiptTitle: intl.formatMessage({
                id: "app.page.transactionReceipt.receipt.title",
            }),
            expiryDate: formatDateWithFixedTime(fxOrderForm.expiryDate!, true)
        }
        return msg;      
    } else {
        return {
            transactionStatus: FX_ORDER_TRANSACTION_ACKNOWLEDGEMENT_STATUS_TYPE.FAIL,
            statusDescription: intl.formatMessage({
                id: "app.page.transactionReceipt.statusDescription.fail.text",
            }),
            statusCode: FX_ORDER_TRANSACTION_ACKNOWLEDGEMENT_STATUS_CODE.FAIL,
            failureMessage: JSON.stringify({
                referenceId: "",
                //@ts-ignore
                orderId: response.data.orderId,
                errorMsg: response.responseCode === FX_ORDER_CONFIRM_STATUS_CODE.WRONG_TAC_ENTERED ? response.data.errorMsg : "",
                "date&time": moment
                    //@ts-ignore
                    .utc(response.data.tradeDate, "YYYYMMDDHHmmss")
                    .local()
                    .format("YYYY-MM-DD HH:mm:ss"),
            }),
        };
    }

}

export const formatFailedCreateFutureOrder = (fxOrderForm: FXOrderFormType) => {
    const intl = getIntlObject();
    const firstCurrencyPair = fxOrderForm?.fx?.currencies[0] ?? "";
    const secondCurrencyPair = fxOrderForm?.fx?.currencies[1] ?? "";
    const currencyPair = `${firstCurrencyPair}/${secondCurrencyPair}`;
  return {
    statusDescription: intl.formatMessage({
      id: "app.page.transactionReceipt.statusDescription.fail.text",
    }),
    statusCode: FX_ORDER_TRANSACTION_ACKNOWLEDGEMENT_STATUS_CODE.FAIL,
    fromAccount: fxOrderForm.bankAccount.source!.id,
    fromAccountName: fxOrderForm.bankAccount.source!.label,
    toAccount: fxOrderForm.bankAccount.target!.id,
    toAccountName: fxOrderForm.bankAccount.target!.label,
    convertedFrom: `${fxOrderForm.source.currency} ${formatDecimal(
      fxOrderForm.source.amount.value,
      DEFAULT_FX_ORDER_CURRENCY_AMOUNT_DECIMAL_POINT
    )}`,
    amountReceived: `${fxOrderForm.target.currency} ${formatDecimal(
      fxOrderForm.target.amount.value,
      DEFAULT_FX_ORDER_CURRENCY_AMOUNT_DECIMAL_POINT
    )}`,
    targetRate: renderRate(
      fxOrderForm.fx!.currencies[0],
      fxOrderForm.fx!.currencies[1],
      fxOrderForm.futureTargetRate!,
      getDpUqBySymbol(fxOrderForm.fx?.symbol!).dp,
      getDpUqBySymbol(fxOrderForm.fx?.symbol!).uq
    ),
    transactionType: intl.formatMessage({
      id: "app.page.transactionReceipt.transactionType.future.text",
    }),
    conversionFee: `${fxOrderForm.fee.currency} ${formatNumber(
      getConversionFee(),
      DEFAULT_FX_ORDER_CURRENCY_AMOUNT_DECIMAL_POINT
    )}`,
    expiryDate: futureOrderFailedFixedTime(fxOrderForm.expiryDate!),
    // @ts-ignore no idea why it sudden give error
    failureMessage: {
      referenceId: "",
      orderId: "",
      "date&time": moment().format("YYYY-MM-DD hh:mmA"),
    },
    transactionStatus: FX_ORDER_TRANSACTION_ACKNOWLEDGEMENT_STATUS_TYPE.FAIL,
    currencyPair: currencyPair ?? "",
  };
};

export const formatFailedMarketOrder = (
  orderId: string,
  fxOrderForm: FXOrderFormType,
  response: any
) => {
  const intl = getIntlObject();
  const fx: FXType = {
    ...formatFXRawList([response.data.symbol])[0],
    bid: isNaN(parseFloat(response.data.rate))
      ? null
      : parseFloat(response.data.rate),
    ask: isNaN(parseFloat(response.data.rate))
      ? null
      : parseFloat(response.data.rate),
  };
  let contraCurrency: string = "-";
  if (fx.currencies[0] === response.data.dealtCurr) {
    contraCurrency = fx.currencies[1] === "" ? "-" : fx.currencies[1];
  } else if (fx.currencies[1] === response.data.dealtCurr) {
    contraCurrency = fx.currencies[0] === "" ? "-" : fx.currencies[0];
  }
  return {
    statusDescription: intl.formatMessage({
      id: "app.page.transactionReceipt.statusDescription.fail.text",
    }),
    statusCode: FX_ORDER_TRANSACTION_ACKNOWLEDGEMENT_STATUS_CODE.FAIL,
    // @ts-ignore no idea why it sudden give error
    failureMessage: {
      referenceId: "",
      orderId,
      "date&time": moment().format("YYYY-MM-DD hh:mmA"),
    },
    transactionStatus: FX_ORDER_TRANSACTION_ACKNOWLEDGEMENT_STATUS_TYPE.FAIL,
    fromAccount: fxOrderForm?.bankAccount?.source?.id ?? "",
    fromAccountName: fxOrderForm?.bankAccount?.source?.label ?? "",
    toAccount: fxOrderForm?.bankAccount?.target?.id ?? "",
    toAccountName: fxOrderForm?.bankAccount?.target?.label ?? "",
    conversionFee: `${fxOrderForm.fee.currency} ${formatNumber(
      getConversionFee(),
      DEFAULT_FX_ORDER_CURRENCY_AMOUNT_DECIMAL_POINT
    )}`,
    orderId: orderId,
    convertedFrom:
      fxOrderForm.source.currency === response.data.dealtCurr
        ? `${response.data.dealtCurr} ${formatNumber(
            response.data.amount,
            DEFAULT_FX_ORDER_CURRENCY_AMOUNT_DECIMAL_POINT
          )}`
        : `${contraCurrency} ${formatNumber(
            response.data.contraAmount,
            DEFAULT_FX_ORDER_CURRENCY_AMOUNT_DECIMAL_POINT
          )}`,
    amountReceived:
      fxOrderForm.target.currency === response.data.dealtCurr
        ? `${response.data.dealtCurr} ${formatNumber(
            response.data.amount,
            DEFAULT_FX_ORDER_CURRENCY_AMOUNT_DECIMAL_POINT
          )}`
        : `${contraCurrency} ${formatNumber(
            response.data.contraAmount,
            DEFAULT_FX_ORDER_CURRENCY_AMOUNT_DECIMAL_POINT
          )}`,
    exchangeRate: getRateByDealt(fxOrderForm.source.currency, fx)
      ? renderRate(
          fx.currencies[0],
          fx.currencies[1],
          getRateByDealt(fxOrderForm.source.currency, fx),
          getDpUqBySymbol(fx.symbol).dp,
          getDpUqBySymbol(fx.symbol).uq
        )
      : "-",
  };
};
